export const JourneyType = {
  ONE_WAY: 'OneWay',
  RETURN: 'Return',
  WAIT_AND_RETURN: 'WaitAndReturn',
  AS_DIRECTED: 'AsDirected',
  FLEXIBLE: 'Flexible',
}

export const ChaufferVehicleType = {
  EXECUTIVE: 'ChaufferExecutive',
  PREMIUM: 'ChaufferPremium',
}

export const CoachVehicleType = {
  STANDARD: 'CoachStandard',
  EXECUTIVE: 'CoachExecutive',
  LUXURY_VIP: 'CoachLuxuryVIP',
}

export const JourneyStatus = {
  ON_TIME: 'On Time',
  LATE: 'Late',
  NOT_DISPATCHED: 'Not Dispatched',
}

export const JourneyTypeButton = {
  TAXI: 'Taxi',
  CHAUFFEUR: 'Chauffeur',
  COACH: 'Coach',
  RIDE_HAIL: 'Ride Hail',
  CAR_HIRE_SHARE: 'Car Hire/Share',
  MICRO_MOBILITY: 'Micro-Mobility',
}
